// import ReactDOM from 'react-dom/client';
import  {render} from 'react-dom'
import { BrowserRouter, Route, Routes } from 'react-router'
import reportWebVitals from './reportWebVitals';
import '../node_modules/mdb-react-ui-kit/dist/css/mdb.min.css'
import "@fortawesome/fontawesome-free/css/all.min.css";
import '../node_modules/react-image-gallery/styles/css/image-gallery.css'
import '../node_modules/mdb-react-ecommerce-gallery/dist/css/ecommerce-gallery.min.css'

import App from './App'
import { MainLayout } from './MainLayout/MainLayout'
import { Home } from './Home/Home'
import { AboutUs } from './AboutUs/AboutUs'
import { ContactUs } from './ContactUs/ContactUs'
import { Projects } from './Projects/Projects'
import { ProjectContent } from './Projects/ProjectsContent/ProjectsContent'
import { MeetOurTeam } from './MeetOurTeam/MeetOurTeam'
import { ProjectsDetail } from './Projects/ProjectsContent/ProjectsDetail/ProjectsDetail'
import { OurStaff } from './MeetOurTeam/MeetOurTeamContent/OurStaff/OurStaff'
import { OurBoardOfAdvisor } from './MeetOurTeam/MeetOurTeamContent/OurBoardOfAdvisor/OurBoardOfAdvisor'
import { Media } from './Media/Media'
import { MediaContent } from './Media/MediaContent/MediaContent'
import { News } from './Media/MediaContent/News/News'
import { Gallery } from './Media/MediaContent/Gallery/Gallery'
import { NewsContent } from './Media/MediaContent/News/NewsContent/NewsContent'
import { NewsDetail } from './Media/MediaContent/News/NewsDetail/NewsDetail'
import { GalleryContent } from './Media/MediaContent/Gallery/GalleryContent/GalleryContent'
import { GalleryDetail } from './Media/MediaContent/Gallery/GalleryDetail/GalleryDetail'



const root = document.getElementById('root')


render(
  <BrowserRouter>
    <Routes>
      <Route element={<App />}>
        <Route element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path={'about_us'} element={<AboutUs />} />
          <Route path={'contact_us'} element={<ContactUs />} />
          <Route path={'projects'} element={<Projects />}>
            <Route index element={<ProjectContent />} />
            <Route path={'project_detail/:index'} element={<ProjectsDetail />} />
          </Route>
          <Route path={'meet_our_team'} element={<MeetOurTeam />}>
            <Route index element={<OurStaff />} />
            <Route path={'our_staff'} element={<OurStaff />} />
            <Route path={'our_board_of_advisor'} element={<OurBoardOfAdvisor />} />
          </Route>
          <Route path={'media'} element={<Media />} >
            <Route element={<MediaContent />}>
              <Route path={'news'} element={<News />}>
                <Route index element={<NewsContent />} />
                <Route path={'news_detail/:id'} element={<NewsDetail />} />
              </Route>
              <Route path={'gallery'} element={<Gallery />} >
                <Route index element={<GalleryContent />} />
                <Route path={'gallery_detail/:id'} element={<GalleryDetail />} />
              </Route>
            </Route>
          </Route>
          <Route path='*' element={<Home />}/>
        </Route>
      </Route>
    </Routes>
  </BrowserRouter>,
  root
);

reportWebVitals();
